import React from "react";
import { useParams } from "react-router-dom";
import { denormalize } from "normalizr";

import Box from "@mui/material/Box";

import { vehicleSchema } from "schemas";
import { TVehicle } from "types";
import { json2normalized } from "fixtures/helper";

import { Backdrop, Suggestion } from "../Detail/components";
import { Typography } from "@mui/material";

import { useSmartNavigate } from "helper/SmartLink";
import { ConfigurationStore } from "stores";

const Archive: React.FC = (): JSX.Element | null => {
  const [vehicle, setVehicle] = React.useState<TVehicle>();
  const configuration = React.useContext(ConfigurationStore);

  const navigate = useSmartNavigate();
  const { id } = useParams();

  // Fetch detailed data
  React.useEffect(() => {
    const dataFetch = async () => {
      const data = await (
        await fetch(
          `${process.env.REACT_APP_API_URL}/archive/${configuration.showroomId || process.env.REACT_APP_SHOP_ID}/${id}`,
        )
      ).json();
      const { vehicle, ...rest } = data;
      if (!vehicle) {
        navigate("/catalog", { replace: true });
        return;
      }

      const { entities } = json2normalized(rest);
      const detail = denormalize(vehicle, vehicleSchema, entities);
      setVehicle(detail);
    };
    dataFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (!vehicle) return null;

  return (
    <>
      <Backdrop vehicle={vehicle} />
      <Typography variant="h6" component="h1">
        Kein verfügbares Fahrzeug gefunden.
      </Typography>
      <Typography variant="body1" component="p">
        Leider war jemand schneller als Sie! Wir haben aber andere attraktive
        Fahrzeuge in unserem Bestand.
      </Typography>
      <Box>
        <Suggestion
          length={8}
          example={vehicle}
          paperProps={{
            variant: "outlined",
            sx: {
              p: 2,
              gridColumn: { md: "span 6" },
            },
          }}
        />
      </Box>
    </>
  );
};

export default Archive;
